import axios from "axios";

const ExternalAccounts = {
  namespaced: true,
  state: {
    all: {
      load: true,
      data: [],
      pagination: null,
    },
    habilitados: {
      load: true,
      data: [],
    },
    beneficiarios: {
      load: true,
      data: [],
    },
    show: null,
  },
  actions: {
    getBeneficiarios: async function ({ commit, rootGetters }, data) {
      commit("setLoad", { k: "beneficiarios", v: true });
      const endpoint = rootGetters[
        "ApiTransferencias/getExternalAccountBeneficiarios"
      ](data.comitente);

      await axios
        .get(endpoint)
        .then((r) => {
          commit("setData", {
            k: "beneficiarios",
            v: r.data.data.beneficiarios,
          });
        })
        .catch((e) => {
          console.error("beneficiarios", e);
        })
        .finally(() => {
          commit("setLoad", { k: "beneficiarios", v: false });
        });
    },
    getHabilitados: async function ({ commit, rootGetters }, data) {
      commit("setLoad", { k: "habilitados", v: true });

      const endpoint = rootGetters[
        "ApiTransferencias/getExternalAccountHabilitados"
      ](data.comitente);

      await axios
        .get(endpoint)
        .then((r) => {
          commit("setData", {
            k: "habilitados",
            v: r.data.data.cuenta_exterior,
          });
        })
        .catch((e) => {})
        .finally(() => {
          commit("setLoad", { k: "habilitados", v: false });
        });
    },
    getAll: async function ({ commit, rootGetters }, data) {
      commit("setLoad", { k: "all", v: true });

      const page = "page" in data ? data.page : 1;
      const endpoint =
        rootGetters["ApiTransferencias/getExternalAccountByComitente"](
          data.comitente
        ) +
        "?perPage=10" +
        "&currentPage=" +
        page;

      await axios
        .get(endpoint)
        .then((r) => {
          commit("setData", { k: "all", v: r.data.data.cuenta_exterior });
          commit("setPagination", { k: "all", v: r.data.data.pagination });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          commit("setLoad", { k: "all", v: false });
        });
    },
    deleteExternalAccount: async function (
      { commit, rootGetters, dispatch },
      data
    ) {
      commit("setLoad", { k: "all", v: true });

      const endpoint = rootGetters[
        "ApiTransferencias/getExternalAccountDelete"
      ](data.comitente, data.id);

      await axios
        .delete(endpoint)
        .then(() => {
          dispatch("getAll", { comitente: data.comitente });
        })
        .catch((e) => {
          if (!!e.response.data.message) {
            if (typeof data.alert != "undefined") {
              data.alert({
                title: "Atención!",
                content: e.response.data.message,
              });
            }
          } else {
            console.warn(e);
          }

          commit("setLoad", { k: "all", v: false });
        });
    },
  },
  mutations: {
    setLoad: function (state, data) {
      state[data.k].load = data.v;
    },
    setData: function (state, data) {
      state[data.k].data = data.v;
    },
    setPagination: function (state, data) {
      state[data.k].pagination = data.v;
    },
  },
};

export default ExternalAccounts;
